"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleEasSettingInputType = void 0;
var SimpleEasSettingInputType;
(function (SimpleEasSettingInputType) {
    SimpleEasSettingInputType["SINGLE_LINE_STRING"] = "SINGLE_LINE_STRING";
    SimpleEasSettingInputType["MULTI_LINE_STRING"] = "MULTI_LINE_STRING";
    SimpleEasSettingInputType["JSON"] = "JSON";
    SimpleEasSettingInputType["INTEGER"] = "INTEGER";
    SimpleEasSettingInputType["DECIMAL"] = "DECIMAL";
    SimpleEasSettingInputType["CHECKBOX"] = "CHECKBOX";
    SimpleEasSettingInputType["SELECT"] = "SELECT";
    SimpleEasSettingInputType["DATE"] = "DATE";
    SimpleEasSettingInputType["TIME"] = "TIME";
    SimpleEasSettingInputType["DATE_TIME"] = " DATE_TIME";
    SimpleEasSettingInputType["INSTANT"] = "INSTANT";
})(SimpleEasSettingInputType = exports.SimpleEasSettingInputType || (exports.SimpleEasSettingInputType = {}));
//# sourceMappingURL=internal-settings-types.js.map